/**
 * Marks the page load that follows a session lost in the browser. The server answers it: a route that
 * needs sign-in redirects to /login with the reason, and a public page renders with the param stripped.
 */
const PARAM = 'session_expired'

export const withSessionExpired = (href: string): string => {
  const url = new URL(href)
  url.searchParams.set(PARAM, '1')
  return url.toString()
}

export const hasSessionExpired = (search: string): boolean => new URLSearchParams(search).has(PARAM)

/** `search` without the marker, `?`-prefixed or empty, ready to append to a path. */
export const stripSessionExpired = (search: string): string => {
  const params = new URLSearchParams(search)
  params.delete(PARAM)
  const rest = params.toString()
  return rest ? `?${rest}` : ''
}
